import React, { Component } from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { PasswordInfo, FieldFactory } from 'client/shared/components';
import { confirmResetPassword } from 'aws-amplify/auth';
import config from 'client/shared/config';

const addProps = (Comp, props) => {
	return class extends Component {
		render () {
			return <Comp { ...props } { ...this.props } />;
		}
	}
};

@inject('formStore', 'userStore')
@observer
class ResetPasswordForm extends Component {
	state = {
		confirmationCode: '',
		newPassword: '',
		confirmPassword: '',
		error: null
	}

	render() {
		const { formStore, userStore } = this.props;
		const { error } = this.state;

		if (userStore.isLoading) {
			return <h1>Logging in...</h1>;
		}

		const Field = addProps(FieldFactory, {
			store: userStore,
			formStore: formStore
		});

		return (
			<div className="grid-x">
				<div className="cell">
					<h4>Reset your password.</h4>
				</div>

				<div className="cell">
					<Field
						label="Confirmation Code"
						fieldKey="confirmationCode"
						changeOnBlur={false}
						noFieldClass
						onChange={(value) => this.setState({ confirmationCode: value })}
					/>

					<Field
						label="New Password"
						fieldKey="newPassword"
						type="password"
						changeOnBlur={false}
						noFieldClass
						onChange={(value) => this.setState({ newPassword: value })}
					/>

					<Field
						label="Confirm Password"
						fieldKey="confirmPassword"
						type="password"
						noFieldClass
						changeOnBlur={false}
						validate={this.validateConfirmPassword}
						onChange={(value) => this.setState({ confirmPassword: value })}
					/>

					<PasswordInfo columns="1" />

					{error && (
						<p style={{color: '#a94442'}}>{error}</p>
					)}

					<div className="padding-top-1">
						<button
							className="button neo login"
							onClick={this.handleSubmit}
							disabled={!this.isValid()}
						>
							Reset Password
						</button>
					</div>
				</div>
			</div>
		);
	}

	isValid() {
		const { confirmationCode, newPassword, confirmPassword } = this.state;
		return (
			confirmationCode &&
			newPassword &&
			confirmPassword &&
			newPassword === confirmPassword
		);
	}

	@autobind
	validateConfirmPassword(confirmPassword) {
		const { newPassword } = this.state;
		return newPassword === confirmPassword;
	}

	@autobind
	async handleSubmit() {
		const { confirmationCode, newPassword } = this.state;
		const { userStore } = this.props;
		
		try {
			await confirmResetPassword({
				username: userStore.get('user.userName'),
				confirmationCode,
				newPassword
			});
			
			// Redirect to login or show success message
			window.location.href = '/login';
		} catch (error) {
			this.setState({
				error: error.message || 'An error occurred while resetting your password.'
			});
		}
	}
}

export default ResetPasswordForm; 